import React from 'react';
import stringUtil from '../../../utils/string/stringUtil';

export default function ColorRenderer(props)
{
    if (stringUtil.isStringNullOrEmpty(props.value)) return null;

    return <div style={{ background: props.value, width: "50px", height: "25px", border: "1px solid gray" }} />;
}